var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"arc"},[_c('arc-el',{attrs:{"border-color":_vm.computedBorderColor,"rotation":_vm.computedRotation,"position-x":_vm.computedPositionX,"position-y":_vm.computedPositionY,"parallax":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }